/* eslint-disable react/require-default-props */
import React, { useRef, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import withFlavors from '../_commons/WithFlavors';
import flavors from './flavors';
import ErrorBoundary from '../../utils/ErrorBoundary';

import Box from '../../elements/Box';
import Row from '../../elements/Row';
import Col from '../../elements/Col';
import Disclaimer from '../../others/Disclaimer';
import FareItemAirline from '../_commons/atoms/FareItemAirline';
import FareItemCallToAction from '../_commons/atoms/FareItemCallToAction';
import FareItemOriginDestinationImage from '../_commons/atoms/FareItemOriginDestinationImage';
import FareItemDepartureInfo from '../_commons/atoms/FareItemDepartureInfo';
import FareItemReturnInfo from '../_commons/atoms/FareItemReturnInfo';
import FareItemOriginDestination from '../_commons/atoms/FareItemOriginDestination';
import FareItemJourneyType from '../_commons/atoms/FareItemJourneyType';
import FareItemTravelClass from '../_commons/atoms/FareItemTravelClass';
import FareItemPrice from '../_commons/atoms/FareItemPrice';
import FareItemRoute from '../_commons/atoms/FareItemRoute';
import FareItemLastSeen from '../_commons/atoms/FareItemLastSeen';
import FareItemTripDuration from '../_commons/atoms/FareItemTripDuration';
import FareItemSale from '../_commons/atoms/FareItemSale';
import Separator from '../_commons/atoms/Separator';
import FareItemMiles from '../_commons/atoms/FareItemMiles';
import FareItemCheckRestriction from '../_commons/atoms/FareItemCheckRestriction';
import { handleFareItemInteraction } from '../_commons/commonFns';
import defaultProps from './defaultProps';

const FareItemMediumSize = (props) => {
  const {
    type,
    usedErrorBoundary,
    showOriginDestinationImage,
    showDepartureInfo,
    showReturnInfo,
    showJourneyType,
    showTravelClass,
    showLastSeen,
    showRoute,
    showPrice,
    showMiles,
    showSale,
    showFareDisclaimer,
    showAirline,
    showCallToAction,
    hideCallToActionOnFocusLeave,
    showDurationTrip,
    showFareItemRouteBeforeDepartureInfo,
    showLastSeenBeforePrice,
    showContentSecondaryInside,
    separatorDatesProps,
    separatorJourneyTypeProps,
    fareItemAirline,
    fareItemCallToAction,
    fareItemCallToActionContainer,
    fareItemDepartureInfo,
    fareItemReturnInfo,
    fareContentItem,
    fareItemOriginDestinationImage,
    fareItemDisclaimer,
    fareItemJourneyType,
    fareItemTravelClass,
    fareItemOriginDestination,
    fareItemPrice,
    fareItemMiles,
    fareItemSale,
    fareItemRoute,
    fareItemTripDuration,
    fareBodyItem,
    fareFooterItem,
    fareImageItem,
    fareImageContainer,
    fareItemLastSeen,
    fareItemDepartureReturn,
    fareItemJourneyTypeTravelClass,
    data,
    focusReferences,
    focusable,
    hoverBody,
    hoverFooter,
    focusClass,
    fareItem,
    onFocus,
    showJourneyTypeTravelClassAtomBeforeDeparture = false,
    fareItemCheckRestriction,
    experimentalRenderAtoms,
    availableAtomsBody,
    availableAtomsFooter,
    availableAtomsContentSecondary,
    onlyFareFooterItem = false,
    fareItemCallToActionContainerAllAtoms,
    fareItemCallToActionTopAtoms,
    ariaHidden = false
  } = props;

  const [hideCallToAction, setHideCallToAction] = useState(null);
  const [lastKeyCode, setLastKeyCode] = useState(null);

  const hideCallToActionOnFocusLeaveAction = () => {
    if (hideCallToActionOnFocusLeave && lastKeyCode === 9) {
      setHideCallToAction(true);
    }
  };

  const handleOnFocus = () => {
    if (hideCallToActionOnFocusLeave && hideCallToAction) {
      setHideCallToAction(false);
    }
    onFocus();
  };

  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const labelButton = fareItemCallToAction.showCallToActionTextMin
    ? translate('fare_call_to_action_label_min', 'Book')
    : translate('fare_call_to_action_label', 'Book now');

  const callToActionLabel = showCallToAction ? labelButton : 'fare-card';

  const {
    handleCallToAction,
    handleClick,
    handleItemKeyDown,
    handleCallToActionKeyDown,
    hasInteraction
  } = handleFareItemInteraction(props, 'fareItemCallToAction', callToActionLabel);

  const handleOnKeyDown = (e) => {
    handleCallToActionKeyDown(e);
    setLastKeyCode(e.keyCode);
  };

  const cursorClass = hasInteraction ? 'fr-cursor-pointer' : '';

  const fareItemRouteAtom = showRoute && data && <FareItemRoute {...fareItemRoute} {...data} />;
  const fareItemLastSeenAtom = showLastSeen && data && (
    <FareItemLastSeen {...fareItemLastSeen} {...data} />
  );
  //TODO: Remove this rules
  // eslint-disable-next-line
  const fareBodyItemRef = useRef(null);
  // eslint-disable-next-line
  const fareFooterItemRef = useRef(null);

  // TODO: (hotfix to support multiple hover) find a better way
  const handleHover = (e) => {
    fareBodyItemRef.current.querySelector('.fare-body-item');
    fareFooterItemRef.current.querySelector('.fare-footer-item');
    if (hoverBody) {
      hoverBody.forEach((el) => {
        fareBodyItemRef.current.classList[e](el);
      });
    }
    if (hoverFooter) {
      hoverFooter.forEach((el) => {
        fareFooterItemRef.current.classList[e](el);
      });
    }
  };

  /**
   * This code is experimental, test mode is added to see how the user can reorder the atoms
   */

  let elements = {};
  if (experimentalRenderAtoms) {
    // 'FareItemAirline',
    // 'FareItemCallToAction',
    // 'FareItemDepartureReturnInfo',
    // 'FareItemJourneyTypeTravelClass',
    // 'FareItemLastSeen',
    // 'FareItemMiles',
    // 'FareItemOriginDestination',
    // 'FareItemPrice',
    // 'FareItemRoute',
    // 'FareItemSale',
    // 'FareItemTripDuration',
    // 'FareItemCheckRestriction',
    // 'FareItemDisclaimer'

    elements = {
      FareItemOriginDestination: (
        <FareItemOriginDestination key="od" {...fareItemOriginDestination} {...data} />
      ),
      FareItemRoute: showRoute && <FareItemRoute key="route" {...fareItemRoute} {...data} />,
      FareItemDepartureReturnInfo: (showDepartureInfo || showReturnInfo) && (
        <Box {...fareItemDepartureReturn} key="drinfo">
          {/* FareItemDepartureInfo */}
          {showDepartureInfo && fareItemDepartureInfo && (
            <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
          )}
          {/* Separator */}
          {showDepartureInfo &&
            showReturnInfo &&
            data.formattedDepartureDate &&
            data.formattedReturnDate && <Separator floatLeft {...separatorDatesProps} />}
          {/* FareItemReturnInfo */}
          {showReturnInfo && fareItemReturnInfo && (
            <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
          )}
        </Box>
      ),
      FareItemSale: showSale && <FareItemSale key="sale" {...fareItemSale} {...data} />,
      FareItemJourneyTypeTravelClass: (showJourneyType || showTravelClass) && (
        <Box {...fareItemJourneyTypeTravelClass} key="class">
          {/* FareItemJourneyType */}
          {showJourneyType && <FareItemJourneyType {...fareItemJourneyType} {...data} />}
          {/* Separator */}
          {showTravelClass && fareItemTravelClass && (
            <Separator {...separatorJourneyTypeProps} floatLeft />
          )}
          {/* FareItemTravelClass */}
          {showTravelClass && <FareItemTravelClass {...fareItemTravelClass} {...data} />}
        </Box>
      ),
      FareItemTripDuration: showDurationTrip && fareItemTripDuration && (
        <FareItemTripDuration key="duration" {...fareItemTripDuration} {...data} />
      ),
      FareItemLastSeen: showLastSeen && data && (
        <FareItemLastSeen key="seen" {...fareItemLastSeen} {...data} />
      ),
      FareItemMiles: showMiles && fareItemMiles && (
        <FareItemMiles key="miles" {...fareItemMiles} {...data} />
      ),
      FareItemPrice: showPrice && fareItemPrice && (
        <FareItemPrice key="price" {...fareItemPrice} {...data} />
      ),
      FareItemAirline: showAirline && fareItemAirline && (
        <FareItemAirline key="airline" {...fareItemAirline} {...data} />
      ),
      FareItemDisclaimer: showFareDisclaimer && fareItemDisclaimer && (
        <Disclaimer key="disclaimer" {...fareItemDisclaimer} {...data} />
      ),
      FareItemCheckRestriction: (
        <FareItemCheckRestriction key="restriction" {...fareItemCheckRestriction} {...data} />
      ),
      FareItemCallToAction: showCallToAction && fareItemCallToAction && !hideCallToAction && (
        <FareItemCallToAction
          key="cta"
          {...fareItemCallToAction}
          {...data}
          onClick={handleCallToAction}
          onKeyDown={handleOnKeyDown}
          onBlur={hideCallToActionOnFocusLeaveAction}
          enabledDataForSR={props.enabledDataForSR}
        />
      )
    };
  }

  /**
   * End experimental
   */

  const contentSecondary = (showAirline || showFareDisclaimer || showCallToAction) && (
    <Box display="flex" flexDirection="column" {...fareItemCallToActionContainer}>
      {experimentalRenderAtoms && availableAtomsContentSecondary.map((e) => elements[e])}
      {!experimentalRenderAtoms && (
        <>
          {/* FareItemAirline */}
          {showAirline && fareItemAirline && <FareItemAirline {...fareItemAirline} {...data} />}
          {/* Disclaimer */}
          {showFareDisclaimer && fareItemDisclaimer && (
            <Disclaimer {...fareItemDisclaimer} {...data} />
          )}
          {/* FareItemCallToAction */}
          {showCallToAction && fareItemCallToAction && !hideCallToAction && (
            <FareItemCallToAction
              {...fareItemCallToAction}
              {...data}
              onClick={handleCallToAction}
              onKeyDown={handleOnKeyDown}
              onBlur={hideCallToActionOnFocusLeaveAction}
              enabledDataForSR={props.enabledDataForSR}
            />
          )}
        </>
      )}
    </Box>
  );

  const journeyTypeTravelClassAtom = (showJourneyType || showTravelClass) && (
    <Box {...fareItemJourneyTypeTravelClass}>
      {/* FareItemJourneyType */}
      {showJourneyType && <FareItemJourneyType {...fareItemJourneyType} {...data} />}
      {/* Separator */}
      {showTravelClass && fareItemTravelClass && (
        <Separator {...separatorJourneyTypeProps} floatLeft />
      )}
      {/* FareItemTravelClass */}
      {showTravelClass && <FareItemTravelClass {...fareItemTravelClass} {...data} />}
    </Box>
  );

  const layoutToRender =
    type === 'layoutRows' ? (
      <Box
        tabIndex={focusable ? 0 : -1}
        focusable={focusable}
        focusReferences={focusReferences}
        dataTestId="fareItem"
        onClick={handleClick}
        onFocus={handleOnFocus}
        onKeyDown={handleItemKeyDown}
        focusClass={focusClass}
        role={showCallToAction ? null : 'button'}
        ariaHasPopUp={showCallToAction ? null : 'dialog'}
        ariaHidden={ariaHidden}
        {...fareItem}
        className={`fare-item-rows ${cursorClass} ${className}`}
        style={style}
      >
        <Box display="flex" rtlReverse>
          {/* FareItemOriginDestinationImage */}
          {showOriginDestinationImage && fareItemOriginDestinationImage && (
            <Box flex={fareImageItem.grow} {...fareImageContainer}>
              <Box height="100" {...fareImageItem}>
                <FareItemOriginDestinationImage {...fareItemOriginDestinationImage} {...data} />
              </Box>
            </Box>
          )}
          {/* fareContentItem */}
          <Box flex={fareContentItem.grow}>
            <Box display="flex" height="100" flexDirection="column" {...fareContentItem}>
              {/* fareBodyItem */}
              <Box flex={fareBodyItem.grow}>
                <Box
                  className="fare-body-item"
                  display="flex"
                  focusReferences={fareBodyItemRef}
                  rtlReverse
                  height="100"
                  flexDirection="column"
                  {...fareBodyItem}
                >
                  {experimentalRenderAtoms && availableAtomsBody.map((e) => elements[e])}
                  {!experimentalRenderAtoms && (
                    <>
                      {/* Shows FareItemRoute before originDestination */}
                      {showFareItemRouteBeforeDepartureInfo && fareItemRouteAtom}
                      {/* FareItemOriginDestination */}
                      <FareItemOriginDestination {...fareItemOriginDestination} {...data} />
                      {/* FareItemRoute */}
                      {!showFareItemRouteBeforeDepartureInfo && fareItemRouteAtom}
                      {showJourneyTypeTravelClassAtomBeforeDeparture && journeyTypeTravelClassAtom}
                      {(showDepartureInfo || showReturnInfo) && (
                        <Box {...fareItemDepartureReturn}>
                          {/* FareItemDepartureInfo */}
                          {showDepartureInfo && fareItemDepartureInfo && (
                            <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
                          )}
                          {/* Separator */}
                          {showDepartureInfo &&
                            showReturnInfo &&
                            data.formattedDepartureDate &&
                            data.formattedReturnDate && (
                              <Separator floatLeft {...separatorDatesProps} />
                            )}
                          {/* FareItemReturnInfo */}
                          {showReturnInfo && fareItemReturnInfo && (
                            <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
                          )}
                        </Box>
                      )}
                      {showSale && <FareItemSale {...fareItemSale} {...data} />}
                      {!showJourneyTypeTravelClassAtomBeforeDeparture && journeyTypeTravelClassAtom}
                    </>
                  )}
                </Box>
              </Box>
              {/* fareFooterItem */}
              <Box flex={fareFooterItem.grow}>
                <Box
                  display="flex"
                  className="fare-footer-item"
                  focusReferences={fareFooterItemRef}
                  rtlReverse
                  height="100"
                  {...fareFooterItem}
                >
                  {experimentalRenderAtoms && availableAtomsFooter.map((e) => elements[e])}
                  {!experimentalRenderAtoms && (
                    <>
                      {/* FareItemTripDuration */}
                      {showDurationTrip && fareItemTripDuration && (
                        <FareItemTripDuration {...fareItemTripDuration} {...data} />
                      )}
                      {showLastSeenBeforePrice && fareItemLastSeenAtom}
                      {/* FareItemMilles */}
                      {showMiles && fareItemMiles && <FareItemMiles {...fareItemMiles} {...data} />}
                      {/* FareItemPrice */}
                      {showPrice && fareItemPrice && <FareItemPrice {...fareItemPrice} {...data} />}
                      {!showLastSeenBeforePrice && fareItemLastSeenAtom}
                    </>
                  )}
                </Box>
              </Box>
              {showContentSecondaryInside && contentSecondary}
            </Box>
          </Box>
        </Box>
        {!showContentSecondaryInside && contentSecondary}
      </Box>
    ) : (
      <Box
        tabIndex={focusable ? 0 : -1}
        focusable={focusable}
        focusReferences={focusReferences}
        display="flex"
        rtlReverse
        className={`fare-item-columns ${cursorClass} ${className} `}
        style={style}
        onClick={handleClick}
        onFocus={handleOnFocus}
        dataTestId="fareItem"
        onKeyDown={handleItemKeyDown}
        onMouseEnter={() => handleHover('add')}
        onMouseLeave={() => handleHover('remove')}
        focusClass={focusClass}
        ariaHidden={ariaHidden}
        {...fareItem}
      >
        {/* FareItemOriginDestinationImage */}
        {showOriginDestinationImage && fareItemOriginDestinationImage && (
          <Box flex={fareImageItem.grow} {...fareImageContainer}>
            <Box
              height={fareItemOriginDestinationImage.rounded !== 'circle' ? '100' : ''}
              {...fareImageItem}
            >
              <FareItemOriginDestinationImage {...fareItemOriginDestinationImage} {...data} />
            </Box>
          </Box>
        )}
        {!onlyFareFooterItem && (
          <Box flex={fareBodyItem.grow}>
            <Box
              display="flex"
              className="fare-body-item"
              focusReferences={fareBodyItemRef}
              rtlReverse
              height="100"
              flexDirection="column"
              {...fareBodyItem}
            >
              {experimentalRenderAtoms && availableAtomsBody.map((e) => elements[e])}
              {!experimentalRenderAtoms && (
                <>
                  {/* Shows FareItemRoute before originDestination */}
                  {showFareItemRouteBeforeDepartureInfo && fareItemRouteAtom}
                  {/* FareItemOriginDestination */}
                  <FareItemOriginDestination {...fareItemOriginDestination} {...data} />
                  {/* FareItemRoute */}
                  {!showFareItemRouteBeforeDepartureInfo && fareItemRouteAtom}
                  {showJourneyTypeTravelClassAtomBeforeDeparture && journeyTypeTravelClassAtom}
                  {(showDepartureInfo || showReturnInfo) && (
                    <Box {...fareItemDepartureReturn}>
                      {/* FareItemDepartureInfo */}
                      {showDepartureInfo && fareItemDepartureInfo && (
                        <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
                      )}
                      {/* Separator */}
                      {showDepartureInfo &&
                        showReturnInfo &&
                        data.formattedDepartureDate &&
                        data.formattedReturnDate && (
                          <Separator floatLeft {...separatorDatesProps} />
                        )}
                      {/* FareItemReturnInfo */}
                      {showReturnInfo && fareItemReturnInfo && (
                        <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
                      )}
                    </Box>
                  )}
                  {showSale && <FareItemSale {...fareItemSale} {...data} />}
                  {!showJourneyTypeTravelClassAtomBeforeDeparture && journeyTypeTravelClassAtom}
                  {/* FareItemTripDuration */}
                  {showDurationTrip && fareItemTripDuration && (
                    <FareItemTripDuration {...fareItemTripDuration} {...data} />
                  )}
                </>
              )}
            </Box>
          </Box>
        )}
        <Box width={onlyFareFooterItem ? '100' : null} flex={fareFooterItem.grow}>
          <Box
            display="flex"
            className="fare-footer-item"
            focusReferences={fareFooterItemRef}
            flexDirection="column"
            rtlReverse
            height="100"
            {...fareFooterItem}
          >
            {experimentalRenderAtoms && availableAtomsFooter.map((e) => elements[e])}
            {!experimentalRenderAtoms && !onlyFareFooterItem && (
              <>
                {/* FareItemMilles */}
                {showMiles && fareItemMiles && <FareItemMiles {...fareItemMiles} {...data} />}
                {/* FareItemPrice */}
                {showPrice && fareItemPrice && <FareItemPrice {...fareItemPrice} {...data} />}
                {fareItemLastSeenAtom}
                {/* FareItemCallToAction */}
                {showCallToAction && fareItemCallToAction && !hideCallToAction && (
                  <Box {...fareItemCallToActionContainer}>
                    <FareItemCallToAction
                      {...fareItemCallToAction}
                      {...data}
                      onClick={handleCallToAction}
                      onKeyDown={handleOnKeyDown}
                      onBlur={hideCallToActionOnFocusLeaveAction}
                      enabledDataForSR={props.enabledDataForSR}
                    />
                  </Box>
                )}
              </>
            )}
            {!experimentalRenderAtoms && onlyFareFooterItem && (
              <Box width="100" flex={fareBodyItem.grow}>
                <Box
                  display="flex"
                  className="fare-body-item"
                  focusReferences={fareBodyItemRef}
                  rtlReverse
                  height="100"
                  flexDirection="column"
                  {...fareBodyItem}
                >
                  <Row width="100" {...fareItemCallToActionContainerAllAtoms}>
                    <Col lg="6" sm="6" xs="6" {...fareItemCallToActionTopAtoms}>
                      {/* FareItemMilles */}
                      {showMiles && fareItemMiles && <FareItemMiles {...fareItemMiles} {...data} />}
                      {/* FareItemPrice */}
                      {showPrice && fareItemPrice && <FareItemPrice {...fareItemPrice} {...data} />}
                      {fareItemLastSeenAtom}
                      {showFareDisclaimer && fareItemDisclaimer && (
                        <Disclaimer key="disclaimer" {...fareItemDisclaimer} {...data} />
                      )}
                    </Col>
                    {/* FareItemCallToAction */}
                    {showCallToAction && fareItemCallToAction && !hideCallToAction && (
                      <Col lg="6" sm="6" xs="6" {...fareItemCallToActionContainer}>
                        <FareItemCallToAction
                          {...fareItemCallToAction}
                          {...data}
                          onClick={handleCallToAction}
                          onKeyDown={handleOnKeyDown}
                          onBlur={hideCallToActionOnFocusLeaveAction}
                          enabledDataForSR={props.enabledDataForSR}
                        />
                      </Col>
                    )}
                  </Row>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );

  return usedErrorBoundary ? <ErrorBoundary>{layoutToRender}</ErrorBoundary> : layoutToRender;
};

FareItemMediumSize.propTypes = {
  /**
   * OnClick event
   */
  onClick: PropTypes.func,
  /**
   * OnClick event
   */
  onFocus: PropTypes.func,
  /**
   * Call to action onClick event
   */
  callToActionOnClick: PropTypes.func,
  /**
   * Kind of FareItem (layout) to be loaded. Can be <code>`layoutColumns`</code>, <code>`layoutRows`</code>.
   */
  type: PropTypes.oneOf(['layoutColumns', 'layoutRows']),
  /**
   * Props of fareItem
   */
  fareItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemCallToAction
   */
  fareItemCallToAction: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemCallToAction container
   */
  fareItemCallToActionContainer: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDepartureInfo
   */
  fareItemDepartureInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemTripDuration
   */
  fareItemTripDuration: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemReturnInfo
   */
  fareItemReturnInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDeparture and fareItemReturn together
   */
  fareItemDepartureReturn: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemJourneyType and fareItemTravelClass together
   */
  fareItemJourneyTypeTravelClass: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemOriginDestinationImage
   */
  fareItemOriginDestinationImage: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemJourneyType
   */
  fareItemJourneyType: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemTravelClass
   */
  fareItemTravelClass: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemOriginDestination
   */
  fareItemOriginDestination: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemPrice
   */
  fareItemPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemMiles
   */
  fareItemMiles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemSale
   */
  fareItemSale: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemRoute
   */
  fareItemRoute: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileBodyItem
   */
  fareBodyItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileFooterItem
   */
  fareFooterItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareImageItem
   */
  fareImageItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareImageContainer
   */
  fareImageContainer: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileContentItem
   */
  fareContentItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemAirline
   */
  fareItemAirline: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDisclaimer
   */
  fareItemDisclaimer: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemLastSeen
   */
  fareItemLastSeen: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of separator
   */
  separatorDatesProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of separator
   */
  separatorJourneyTypeProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the journeyType section
   */
  showOriginDestinationImage: PropTypes.bool,
  /**
   * Turn off or on the journeyType section
   */
  showJourneyType: PropTypes.bool,
  /**
   * Turn off or on the showDurationTrip section
   */
  showDurationTrip: PropTypes.bool,
  /**
   * Turn off or on the travelClass section
   */
  showTravelClass: PropTypes.bool,
  /**
   * Turn off or on the DepartureInfo section
   */
  showDepartureInfo: PropTypes.bool,
  /**
   * Turn off or on the ReturnInfo section
   */
  showReturnInfo: PropTypes.bool,
  /**
   * Turn off or on the LastSeen section
   */
  showLastSeen: PropTypes.bool,
  /**
   * Turn off or on the Route section
   */
  showRoute: PropTypes.bool,
  /**
   * Turn off or on the Price section
   */
  showPrice: PropTypes.bool,
  /**
   * Turn off or on the Miles section
   */
  showMiles: PropTypes.bool,
  /**
   * Turn off or on the Fare Disclaimer section
   */
  showFareDisclaimer: PropTypes.bool,
  /**
   * Turn off or on the Airline section
   */
  showAirline: PropTypes.bool,
  /**
   * Turn off or on the Call To Action section
   */
  showCallToAction: PropTypes.bool,
  /**
   * Show sale atom
   */
  showSale: PropTypes.bool,
  /**
   * Show FareItemRoute before FareItemDepartureInfo
   */
  showFareItemRouteBeforeDepartureInfo: PropTypes.bool,
  /**
   * Show FareItemLastSeen before FareItemPrice
   */
  showLastSeenBeforePrice: PropTypes.bool,
  /**
   * Raw data passed to the object
   */
  data: PropTypes.objectOf(PropTypes.any),
  /**
   * ref
   */
  focusReferences: PropTypes.func,
  /**
   * Turn off or on tabIndex in FareItem
   */
  focusable: PropTypes.bool,
  /**
   * Flavor of the fareItem
   */
  flavor: PropTypes.oneOf([
    'alliance',
    'allianceNoDisclaimer',
    'airlineOneWay',
    'airlineOneWayBasic',
    'airlineOneWayBiTones',
    'airlineOneWayNoDisclaimer',
    'airlineOneWayNoImage',
    'airlineOneWayThin',
    'airlineOneWayThinColumns',
    'airlineOneWayWithButton',
    'airlineRoundTrip',
    'airlineRoundTripBasic',
    'airlineRoundTripBiTones',
    'airlineRoundTripColumns',
    'airlineRoundTripNoDisclaimer',
    'airlineRoundTripNoImage',
    'airlineRoundTripOneLine',
    'airlineWithButtonRoundTrip',
    'roundedImage',
    'airlineRoundTripBasicDesktop',
    'airlineRoundTripWithImageDesktop',
    'airlineRoundTripNoImageDesktop',
    'airlineRoundTripBiTonesDesktop',
    'airlineRoundTripDesktop',
    'airlineOneWayBasicDesktop',
    'airlineOneWayDesktop',
    'airlineOneWayNoImageDesktop',
    'airlineOneWayBiTonesDesktop',
    'fareItemCarousel',
    'fareItemPopularDestinations',
    'biColorOneWay',
    'destinationImageOneWay',
    'fullCard',
    'classicRoundTrip',
    'essentialOneWay',
    'basicRoundTrip',
    'fareItemFeaturedTopDestinations',
    'fareItemFeaturedDestinations',
    'fareItemFeaturedTopDestinationsMobile',
    'fareItemFeaturedDestinationsLight',
    'roundtripRoundedImageSimple',
    'fareItemFeaturedDestinationsMobile'
  ]),
  /**
   * Possible interactions will be Popup or Direct Deeplink
   */
  interactionHotZone: PropTypes.oneOf(['smart', 'whole', 'button']),
  /**
   * Determine if the component is protected using ErrorBoundary.
   * By default all components protect themselves
   */
  usedErrorBoundary: PropTypes.bool,
  /**
   * Data test ID of FareItem
   */
  dataTestId: PropTypes.string,
  /**
   * class applied when fareItemBody is hover
   */
  hoverBody: PropTypes.PropTypes.arrayOf(PropTypes.string),
  /**
   * class applied when fareItemFooter is hover
   */
  hoverFooter: PropTypes.arrayOf(PropTypes.string),
  /**
   * Define class to focus
   */
  focusClass: PropTypes.string,
  /**
   * showContentSecondaryInside or not.
   */
  showContentSecondaryInside: PropTypes.bool,
  /**
   * Show JourneyType and TravelClass Atoms before
   */
  showJourneyTypeTravelClassAtomBeforeDeparture: PropTypes.bool,
  /**
   * Use this feature only at your own risk
   */
  experimentalRenderAtoms: PropTypes.bool,
  availableAtomsBody: PropTypes.arrayOf(
    PropTypes.oneOf([
      'FareItemAirline',
      'FareItemCallToAction',
      'FareItemDepartureReturnInfo',
      'FareItemJourneyTypeTravelClass',
      'FareItemLastSeen',
      'FareItemMiles',
      'FareItemOriginDestination',
      'FareItemPrice',
      'FareItemRoute',
      'FareItemSale',
      'FareItemTripDuration',
      'FareItemDisclaimer',
      'FareItemCheckRestriction'
    ])
  ),
  availableAtomsFooter: PropTypes.arrayOf(
    PropTypes.oneOf([
      'FareItemAirline',
      'FareItemCallToAction',
      'FareItemDepartureReturnInfo',
      'FareItemJourneyTypeTravelClass',
      'FareItemLastSeen',
      'FareItemMiles',
      'FareItemOriginDestination',
      'FareItemPrice',
      'FareItemRoute',
      'FareItemSale',
      'FareItemTripDuration',
      'FareItemDisclaimer',
      'FareItemCheckRestriction'
    ])
  ),
  availableAtomsContentSecondary: PropTypes.arrayOf(
    PropTypes.oneOf([
      'FareItemAirline',
      'FareItemCallToAction',
      'FareItemDepartureReturnInfo',
      'FareItemJourneyTypeTravelClass',
      'FareItemLastSeen',
      'FareItemMiles',
      'FareItemOriginDestination',
      'FareItemPrice',
      'FareItemRoute',
      'FareItemSale',
      'FareItemTripDuration',
      'FareItemDisclaimer',
      'FareItemCheckRestriction'
    ])
  )
};

FareItemMediumSize.componentName = 'FareItemMediumSize';

FareItemMediumSize.flavors = flavors;

export default withFlavors(FareItemMediumSize, defaultProps);
